import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import NumberInput from "../../input/number-input";

const Number1Widget = ({ widget, onValueUpdate }) => {
  const [v0, setV0] = useState(null);

  useEffect(() => {
    setV0(widget);
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...v0, value: data.toString() };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "2px",
      }}
    >
      {v0 && <NumberInput valueSpec={v0} onChange={handleValueUpdate} />}
    </Box>
  );
};

export default Number1Widget;
